import React from 'react'

import { API_BASE_URL } from '../../config/api'
import { clickableProps } from '../../utils/clickableProps'

const PhotoGrid = ({
  scrollRef,
  photos,
  isDragging,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onMouseLeave,
  onPhotoClick
}) => {
  return (
    <div
      ref={scrollRef}
      className={`flex overflow-x-hidden carousel-container p-4 ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      style={{ userSelect: 'none' }}
    >
      {photos.map((photo, index) => (
        <PhotoItem
          key={`${photo._id}-${index}`}
          photo={photo}
          onClick={(e) => onPhotoClick(photo, e)}
        />
      ))}
    </div>
  )
}

const PhotoItem = React.memo(({ photo, onClick }) => (
  <div
    className="flex-shrink-0 w-64 h-48 relative group mr-4 last:mr-0 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
    {...clickableProps(onClick, `Open photo ${photo.customName || photo.originalName || ''}`)}
  >
    <img
      src={`${API_BASE_URL}${photo.path}`}
      alt={photo.customName || photo.originalName}
      className="w-full h-full object-cover rounded-lg transition-transform duration-300 group-hover:scale-105"
      loading="lazy"
      decoding="async"
      onError={(e) => {
        e.target.style.display = 'none'
      }}
    />

    <PhotoOverlay photo={photo} />
  </div>
))

const PhotoOverlay = React.memo(({ photo }) => (
  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 rounded-lg">
    <div className="absolute bottom-2 left-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
      <p className="text-white text-sm font-medium truncate">
        {photo.customName || photo.originalName}
      </p>
      <p className="text-gray-300 text-xs truncate">
        {photo.eventName}
      </p>
      {photo.description && (
        <p className="text-gray-400 text-xs truncate">
          {photo.description}
        </p>
      )}
    </div>
  </div>
))

export default PhotoGrid